import { GetStaticProps, NextPage } from "next";

import { BluetoothLandingPage } from "@components/bluetooth-landing/BluetoothLandingPage";
import * as copy from "@data/backend-panels-landing/plCopy";

const BackendIPaneleAdministracyjnePage: NextPage = () => (
  <BluetoothLandingPage
    metadata={{
      title: copy.title,
      description: copy.description,
      canonicalPath: "/backend-i-panele-administracyjne",
      lang: "pl",
      ogLocale: "pl_PL",
      structuredData: copy.structuredData,
      alternatePaths: {
        pl: "/backend-i-panele-administracyjne",
        xDefault: "/backend-i-panele-administracyjne",
      },
    }}
    heroCopy={copy.heroCopy}
    targetAudienceCopy={copy.targetAudienceCopy}
    valuePropositionCopy={copy.valuePropositionCopy}
    servicesCopy={copy.servicesCopy}
    processCopy={copy.processCopy}
    aboutUsCopy={copy.aboutUsCopy}
    faqCopy={copy.faqCopy}
    footerCopy={copy.footerCopy}
  />
);

export const getStaticProps: GetStaticProps = async () => ({
  props: {},
});

export default BackendIPaneleAdministracyjnePage;
